import { render, staticRenderFns } from "./TheReassignWorkflowAction.vue?vue&type=template&id=6ab80597"
import script from "./TheReassignWorkflowAction.vue?vue&type=script&lang=ts"
export * from "./TheReassignWorkflowAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports